<template>
  <div class="charging-operation">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <div class="sub-title">基本信息</div>
      <el-form-item label="仓库" prop="warehouseId">
        <el-select
          class="white"
          v-model="ruleForm.warehouseId"
          placeholder="请选择仓库"
          @change="changeWarehouse"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-select
          class="white"
          v-model="ruleForm.projectName"
          placeholder="请选择项目"
          @change="changeProjectName"
        >
          <el-option
            v-for="item in projectNameList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期" prop="date">
        <el-date-picker
          v-model="ruleForm.date"
          type="date"
          placeholder="请选择日期"
          :picker-options="pickerOptions"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <div class="sub-title">服务内容</div>
      <el-form-item label="数量" prop="nums">
        <el-input
          class="white input-div"
          v-model="ruleForm.nums"
          placeholder="请输入数量"
          @input="inputTwoNums(ruleForm.nums)"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="单价" prop="unitPrice">
        <el-select
          class="white"
          v-model="ruleForm.unitPrice"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in stickerList"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="金额" prop="amount">
        <el-input
          class="white input-div"
          v-model="ruleForm.amount"
          placeholder="待计算"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input
          type="textarea"
          class="white remarks"
          v-model="ruleForm.remarks"
          placeholder="请填写信息"
          clearable
        ></el-input>
      </el-form-item>
      <div class="footer">
        <el-button @click="cancel('ruleForm')">清空</el-button>
        <el-button
          class="btn-blue"
          @click="submitForm('ruleForm')"
          >保存</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import ChargeRegister from "models/charge-register";
import warehouseMixins from "@/common/mixins/warehouse.js"
import chargeMixins from "@/common/mixins/charge-operator.js"
import { formatTimeToDate, inputAllTwoDecimal } from "common/js/util";
export default {
  mixins: [warehouseMixins, chargeMixins],
  data() {
    return {
      projectNameList: [],
      ruleForm: {
        warehouseId: "",
        date: formatTimeToDate(new Date()),
        customerId: "",
        projectName: "",
        remarks: "",
        nums: "",
        unitPrice: "",
        amount: "",
        // 1: 大宗出库; 2:退货服务; 3: 卸货服务; 4:增值服务
        serviceContent: 3
      },
      rules: {
        warehouseId: [
          {
            required: true,
            message: "请选择仓库",
            trigger: "change",
          },
        ],
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        customerId: [
          {
            required: true,
            message: "请选择货主",
            trigger: "change",
          },
        ],
        projectName: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
        ],
        nums: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        unitPrice: [
          {
            required: true,
            message: "请选择单价",
            trigger: "change",
          },
        ],
      },
    };
  },

  async created() {
    await this.initAsyncWarehouse()
    this.ruleForm.warehouseId = this.warehouseList[0].id;
    this.initProjectList(this.ruleForm.warehouseId, 'fromBase')
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data
          let warehouseId = this.ruleForm.warehouseId;
          let billDate = this.ruleForm.date;
          let customerId = this.ruleForm.customerId;
          let projectId = this.ruleForm.projectName;
          let checkNum = Number(this.ruleForm.nums);
          let unitPrice = Number(this.ruleForm.unitPrice);
          let remarks = this.ruleForm.remarks;
          data = {
            warehouseId,
            customerId,
            projectId,
            billDate,
            remarks,
            checkNum,
            unitPrice,
          };
          ChargeRegister.postUnloadingSave(data).then((res) => {
            if (res.success) {
              this.$message.success('保存成功');
              this.cancel('ruleForm')
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
    cancel(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.warehouseId = this.warehouseList[0].id;
    },
    
    /* 限制数量为2位小数，可以为负 */
    inputTwoNums(val) {
      this.ruleForm.nums = inputAllTwoDecimal(val);
    },
  },
};
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/charging-operation.scss";
</style>
